import { createContext, useContext, useState } from 'react';

const HamburgerMenuContext = createContext();

export const HamburgerMenuProvider = ({ children }) => {
    const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);

    return (
        <HamburgerMenuContext.Provider value={{ isHamburgerOpen, setIsHamburgerOpen }}>
            {children}
        </HamburgerMenuContext.Provider>
    );
};

export const useHamburgerMenu = () => useContext(HamburgerMenuContext);
